import { useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { APP_Config } from "./utils/AppConfig";
import TimerModal from "./components/shared/TimerModal";
import Service from "./services";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "./utils/Utils";
import { BankUserContext } from "./bankUserContext";

const timeout = 30 * 60 * 1000; // 30 minutes in milliseconds
const promptBeforeIdle = 5 * 60 * 1000; // 5 minutes in milliseconds

export default function SessionTimeout() {
  const [state, setState] = useState<string>("Active");
  const [remaining, setRemaining] = useState<number>(timeout);
  const [firstPopUp, setFirstPopUp] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);
  const bankUserContext = useContext(BankUserContext);

  const service = new Service();

  const urlSegments = window.location.href.split("/");
  const currentUrl = window.location.href;

  const onIdle = () => {
    if (!currentUrl.includes("sessiontimeoutpage")) {
      setState("Idle");
      message("foo", true);
      setFirstPopUp(false);
      directLogout(true)      //sessionLogout  boolean=true

    }
  };

  const onActive = () => {
    setState("Active");
  };

  const onPrompt = () => {
    if (!currentUrl.includes("sessiontimeoutpage")) {
      setState("Prompted");
      setFirstPopUp(true);
    }
  };
  const directSessionLogout = () => {
    logoutbtn(false)
  }

  const onMessage = (value: string) => {
    if (value === "Log Out") {
      const delayInMilliseconds = 100; //100 milli seconds
      setTimeout(directSessionLogout, delayInMilliseconds);  //directLogout boolean=false
      setFirstPopUp(false);
    } else if (value === "Extend Session") {
      activate();
      setFirstPopUp(false);
    }
  };

  const {
    getRemainingTime,
    activate,
    getTabId,
    isLeader,
    isLastActiveTab,
    message,
  } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    onMessage,
    timeout,
    promptBeforeIdle,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  const handleStillHere = (value: string) => {
    if (value === "Log Out") {
      message("Log Out", true);
    } else if (value === "Extend Session") {
      message("Extend Session", true);
    }
  };



  const directLogout = (value: boolean) => {
    const accesstoken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userId = bankUserContext?.bankuserDetails?.userId;

    window.location.href = `${APP_Config().REACT_APP_LOGOUT
      }?accesstoken=${accesstoken}&refreshtoken=${refreshToken}&sessionExpired=${value}&clientId=${APP_Config().REACT_APP_CLIENT_ID
      }&userId=${userId}`;
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("errorMessageList");
    sessionStorage.removeItem("archiveData")


  };

  const logoutbtn = (value: boolean) => {
    const accesstoken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userId = bankUserContext?.bankuserDetails?.userId;

    const data = {
      accessToken: accesstoken,
      refreshToken: refreshToken,
      clientId: APP_Config().REACT_APP_CLIENT_ID,
      sessionExpired: value,
      userId:userId
    }
    service
      .logOut(data)
      .then((response: AxiosResponse<any>) => {
        directLogout(value)


      })
      .catch((error: AxiosError) => {
        catchError(error, true);

      });
  }

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  const timer = () => {
    return (
      <>
        {minutes}:{seconds < 10 ? "0" + seconds : seconds}
      </>
    );
  };

  const timerConfirmText = () => (
    <>
      <p className="firstText">
        Your session will expire in{" "}
        {remaining > 0 && <span className="timeUnits">{timer()}</span>}
      </p>
      <div>
        <span className="text">
          Extend Session to continue working <br />
          Log Out to end your session now
        </span>
      </div>
    </>
  );

  return (
    <>
      <TimerModal
        className="confirmLeadCreated moveContactModal timer"
        headerText={"Session Timeout"}
        confirmCloseHandle={handleStillHere}
        confirmCloseModel={firstPopUp}
        firstBtn={"Log Out"}
        secondBtn={"Extend Session"}
        confirmText={timerConfirmText()}
      />
    </>
  );
}
